const columns = [
  {
    title: '内容入口',
    links: [
      { label: '热听大图卡片流', href: '#hot' },
      { label: '分类入口', href: '#categories' },
      { label: '本周收听榜', href: '#ranking' },
    ],
  },
  {
    title: '了解我们',
    links: [
      { label: '整理方式说明', href: '#trust' },
      { label: '收录规模', href: '#trust' },
      { label: '常见疑问', href: '#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-mic-2-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-background-50 text-lg tracking-tight">
                黑料吃话
              </span>
            </div>
            <p className="mt-4 text-sm font-label text-primary-100/80 leading-relaxed max-w-sm">
              黑料吃话语音原声整理入口。把录音、对话片段和长录音放在一起，
              让了解事件来龙去脉这件事变得更快。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {['ri-mic-line', 'ri-headphone-line', 'ri-music-2-line', 'ri-equalizer-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md bg-background-50/10 text-accent-400 flex items-center justify-center"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {/* link columns */}
          {columns.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <h4 className="font-heading font-semibold text-background-50 text-sm">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs font-label text-primary-100/75 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* note */}
          <div className="md:col-span-1 hidden md:block"></div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[11px] font-label text-primary-100/70 leading-relaxed">
            页面内容为展示用整理示意，音频版权归原记录者所有；如有异议可申请下架。
          </p>
          <p className="text-[11px] font-label text-primary-100/70 whitespace-nowrap">
            © 2026 黑料吃话 · 语音内容聚合入口
          </p>
        </div>
      </div>
    </footer>
  );
}